// File: noviopus-ats-client/src/utils/safeImmutable.ts
import { Iterable, fromJS } from 'immutable';

/**
 * Accessor for the new POJO Root Architecture.
 * 
 * If accessing `safeGet(state, 'auth')` -> returns state.auth
 * If accessing `safeGet(state.companies, 'list')` -> returns immutable lookup
 */
export function safeGet(state: any, key: string, defaultValue: any = undefined) {
  if (!state) return defaultValue;
  
  // 1. Immutable Map
  if (Iterable.isIterable(state) && typeof state.get === 'function') {
    return state.get(key, defaultValue);
  }
  
  // 2. POJO
  return state[key] !== undefined ? state[key] : defaultValue;
}

export function safeGetIn(state: any, path: string[], defaultValue: any = undefined) {
  if (!state) return defaultValue;

  // 1. Immutable Map
  if (Iterable.isIterable(state) && typeof state.getIn === 'function') {
    return state.getIn(path, defaultValue);
  }

  // 2. POJO Traversal
  let current = state;
  for (let i = 0; i < path.length; i++) {
    const key = path[i];
    
    if (current === null || current === undefined) return defaultValue;

    // If we hit an Immutable object mid-traversal
    if (Iterable.isIterable(current) && typeof current.get === 'function') {
        return current.getIn(path.slice(i), defaultValue);
    }

    current = current[key];
  }

  return current !== undefined ? current : defaultValue;
}

export function ensureImmutable(state: any) {
  // In the new architecture, Root is POJO.
  // We generally DO NOT want to force immutable on the root anymore.
  // This function is kept for legacy reducers that might call it internally.
  if (state && !Iterable.isIterable(state)) {
    return fromJS(state);
  }
  return state;
}